<script lang="ts">
  import DatePicker from "./Components/DatePicker.svelte";
  import ImagePreview from "./Components/ImagePreview.svelte";
  import Upload from "./Components/Upload.svelte";
  import { onMount } from "svelte";

  const leafletControl = {
    name: "leaflet_title",
    value: "",
  };

  let startDate;

  onMount(async () => {
    // startDate = new Date().toISOString().split("T")[0];
  });
</script>

<main>
  <div class="upload_section">
    <Upload
      name="intentions"
      uploadTitle="Prijenos nakana"
      uploadActionTitle="Prenesi nakane"
      acceptFileTypes="application/pdf"
      wp_ajax_action="a3_upload_intentions"
    />
  </div>
  <div class="upload_section">
    <Upload
      name="news"
      uploadTitle="Prijenos obavijesti"
      uploadActionTitle="Prenesi obavijesti"
      acceptFileTypes="application/pdf"
      wp_ajax_action="a3_upload_news"
    />
  </div>

  <div class="upload_section">
    <Upload
      name="leaflet"
      uploadTitle="Prijenos listića"
      uploadActionTitle="Prenesi listiće"
      acceptFileTypes="image/png, image/jpeg, image/gif, image/webp"
      wp_ajax_action="a3_upload_leaflet"
      multiple={true}
    >
      <div slot="after_file" let:files let:addAdditionalFormData>
        <ImagePreview {files} />
        <label
          >Naslov listića: <input
            name={leafletControl.name}
            type="text"
            bind:value={leafletControl.value}
            on:keyup={(ev) =>
              addAdditionalFormData(leafletControl.name, leafletControl.value)}
          /></label
        >
        <label
          >Datum listića: <input type="text" bind:value={startDate} />
          <DatePicker
            bind:value={startDate}
            on:change={(ev) => {
              console.log(ev);
              addAdditionalFormData("leaflet_date", ev.detail);
            }}
          /></label
        >
      </div>
    </Upload>
  </div>
</main>

<style>
  main {
    /* text-align: center; */
    padding: 1em;
    max-width: 240px;
    margin: 0 auto;
    font-family: Arial, Helvetica, sans-serif;
  }

  label {
    display: block;
    padding: 10px;
  }

  .upload_section {
    padding: 10px;
  }

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
</style>
